import { render, staticRenderFns } from "./ReiseDatenDetails.vue?vue&type=template&id=7f28d054&scoped=true"
import script from "./ReiseDatenDetails.vue?vue&type=script&lang=ts"
export * from "./ReiseDatenDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReiseDatenDetails.vue?vue&type=style&index=0&id=7f28d054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f28d054",
  null
  
)

export default component.exports